export default {
  product: {
    tab2: {
      download: 'Descargar',
    },
    tab5: {
      manufacturer: 'Fabricante',
      part_number: 'Número de parte',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/catalog/product.js